module.exports = __webpack_public_path__ + "static/media/lauren-mcbride.1c0a441c.md";